import React, { useEffect, useState, useContext } from "react";
import { Button, Card, Container, Form } from "react-bootstrap";
import Select from "react-select";
import { Helmet } from "react-helmet-async";
import Breadcrumbs from "../../../../components/common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import ModalDelete from "../../../../components/common/ModalDelete";
import NotyfContext from "../../../../contexts/NotyfContext";
import { isEmpty } from "lodash";
import axios from "axios";
// Icons
import { MdAdd, MdSearch } from "react-icons/md";

// Components
import Parliaments from "./components/tables/Parliaments";
import ParliamentForm from "./components/modals/ParliamentForm";

// Redux
import {
  fetchParliaments,
  removeParliament,
} from "../../../../redux/slices/state-information/parliamentsSlice";
import { getDistrictItems } from "../../../../redux/slices/utilsSlice";

const MainPage = () => {
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);

  const [openForm, setOpenForm] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [item, setItem] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState("");

  const { isLoading, btnLoading, parliaments } = useSelector((state) => ({
    parliaments: state.parliamentReducer.parliaments,
    btnLoading: state.parliamentReducer.btnLoading,
  }));

  const filteredData = parliaments?.filter((item) => {
    let isFilterPassed = true;

    if (!isEmpty(searchText)) {
      isFilterPassed =
        isFilterPassed &&
        item.name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
    }

    return isFilterPassed;
  });

  const handleCloseForm = () => {
    setOpenForm(false);
    setIsEdit(false);
    setItem({});
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleEditItem = (item) => {
    setIsEdit(true);
    setOpenForm(true);
    setItem(item);
  };

  const handleRemoveItem = (item) => {
    setShowRemove(true);
    setItem(item);
  };

  const handleCloseRemove = () => {
    setShowRemove(false);
    setItem({});
    // handleResetState();
  };

  const handleConfirmRemove = async (data) => {
    await dispatch(removeParliament(data.id));
    handleNotification("error", data);
    handleCloseRemove();
  };

  // Notification
  const handleNotification = (type, values) => {
    let msg = "";
    let color = "success";

    switch (type) {
      case "error":
        color = "error";
        msg = `Maklumat ${values?.name} berjaya dipadam.`;
        break;
      case "edited":
        msg = `Maklumat ${values?.name} berjaya dikemaskini.`;
        break;

      default:
        msg = `Maklumat ${values?.name} berjaya dicipta.`;
        break;
    }

    // Success
    notyf.open({
      type: color,
      message: msg,
      duration: 5000,
      ripple: false,
      dismissible: true,
      position: {
        x: "right",
        y: "top",
      },
    });
  };

  useEffect(() => {
    let isMounted = true;

    const source = axios.CancelToken.source();

    const props = {
      source: source,
    };

    if (isMounted) {
      dispatch(getDistrictItems(props));
      dispatch(fetchParliaments());
    }

    return () => {
      isMounted = false;
      source.cancel("Component unmounted, canceling requests");
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <ModalDelete
        showRemove={showRemove}
        closeRemove={handleCloseRemove}
        data={item}
        confirmRemove={handleConfirmRemove}
        btnLoading={btnLoading}
      />

      <ParliamentForm
        showForm={openForm}
        closeForm={handleCloseForm}
        handleNotification={handleNotification}
        isEdit={isEdit}
        data={item}
      />

      <Helmet title='Senarai Parlimen' />
      <Container fluid className='p-0'>
        <Breadcrumbs
          title='Maklumat Negeri'
          breadcrumbItem='Senarai Parlimen'
        />
        <Card className='mt-3'>
          <Card.Header>
            <div className='card-actions float-end'>
              <Button onClick={handleOpenForm}>
                <MdAdd /> Parlimen
              </Button>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <div className='search-box-custom'>
                <div className='position-relative'>
                  <label htmlFor='search-bar-0' className='search-label-custom'>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Cari Parlimen...'
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{ width: 250 }}
                    />
                  </label>
                  <MdSearch className='search-icon-2' size={18} />
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Parliaments
              parliaments={filteredData}
              handleEditItem={handleEditItem}
              handleRemoveItem={handleRemoveItem}
            />
          </Card.Body>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default MainPage;
